import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';

@Component({
  selector: 'app-emp-details',
  templateUrl: './emp-details.component.html',
  styleUrls: ['./emp-details.component.css']
})
export class EmpDetailsComponent implements OnInit {
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };
  states: string[] = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
    'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
    'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
    'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
    'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands',
    'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
    'Lakshadweep', 'Delhi', 'Puducherry'
  ];
  uploadDir: string = environment.uploadDir;
  @ViewChild('fileInput') fileInput;
  selectedOption: string;
  uploads_name: any = {};
  model: any;
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {
    cert_details: []
  };
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  savecertList: any;
  fieldName: string;
  fileList: FileList;
  certId: any;
  fileU: boolean;
  formedata: FormData;
  onlyview: boolean = false;
  options: any;
  getuintofmeasurement: any;
  formdata: FormData;
  upname: any;
  targetfile: any;
  Emp_Id: any;
  headerLabel: string;
  appSug: any = {};
  designations: any = [];
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService

  ) {
    this.uploads_name.inventory_manager_upload_path = {
      file_name: '',
      file_temp_name: '',
    };
    this.initVar();
    this.appSug = { lname: '' };

  }
  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    var checkAccess = this.checkModuleAcces('2');
    if (!checkAccess) {
      alert("You don't have access for this module. Please contact admin.")
      this.router.navigate(['/Selectport']);
      return;
    }
  }


  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => this.searching = true)
      .switchMap(term =>
        this.loginservice.getemployeeterm(term, 'employee_profile', this.currentUser)
          .do(() => this.searchFailed = false)
          .catch(() => {
            this.searchFailed = true;
            return Observable.of([]);
          }))
      .do(() => this.searching = false)
      .merge(this.hideSearchingWhenUnsubscribed)
  formatter = (x: { f_name: string }) => '';

  asignModel(n) {

    if (typeof n === 'object') {

      this.model = n;
      this.Emp_Id = n.id;
      // if (typeof this.app.interview_date !== 'object') {
      //   this.app.interview_date = this._common.strToDates(n.interview_date);
      // }      

    } else {
      // this.initVar();
    }
  }

  initVar() {
    this.appSug = { f_name: '' }
    this.model = {
      ...this.model,
      phone: '',
      gender: '',
      // work_type: '1',
      // work_status: '1',
      designation: '',
      // f_name: n,
      email: '',
      resume_path: '',
      id: '',
      f_name: '',
      work_status: '',
      work_type: '',
      dob: '',
      joining_date: '',
      address: '',
      state: '',
      salary: '',
      city: '',
      zip: '',
      treading: false,
      facial: false,
      laser: false,
      waxing: false,
      hair_treat: false,
      haircut: false,
      haircolor: false,
      smothening: false,
      straightening: false,
      pedicure: false,
      manicure: false,
      cut_file: false,
      tan: false


    };
  }


  saveemp() {
    this.showLoader = true;
    this.loginservice.saveemp(this.model, this.currentUser)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
            this.showLoader = false;
            if (this.targetfile) {
              let epID = ''
              if (this.Emp_Id) {
                epID = this.Emp_Id
              } else {
                epID = data['comp_details']['0']['id'];
              }
              this.uploadmanager(this.formdata, this.upname, epID)
            } else {
              // this.router.navigate(['/inventory-manager']);
            }
            this.model = data['comp_details'][0];
          } else if (data['status'] === 'duplicate') {
            this._flashMessagesService.show(data['msg'], { cssClass: 'alert-danger' });
            this.showLoader = false;
          } else {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
            this.showLoader = false;
          }
        },
        error => {
          alert('Network Error save emp API');
        });
  }


  upload(f, name) {

    // if (this.model.id) {
    if (f.target.files[0]) {
      const formData = new FormData();
      formData.append(name, f.target.files[0]);
      this.formdata = formData;
      this.upname = name;
      this.targetfile = f.target.files[0];
      this.uploads_name.inventory_manager_upload_path = { file_name: f.target.files[0].name };
      this.model.resume_path = f.target.files[0].name;
    }
    // } else {
    //   this._flashMessagesService.show('Please Choose Employee', { cssClass: 'alert-danger' });
    // }

  }

  uploadmanager(formData, name, Emp_Id) {
    this.loginservice.uploadFile1(formData, name, Emp_Id, '', 'id', 'employee_profile').subscribe(r => {
      if (r['status'] === 'success') {
        var path_name = name + '_path';
        this.uploads_name[path_name] = r;
        this.model['resume_temp_path'] = r['resume_temp_path'];
        this.model['resume_path'] = r['file_name'];
        // this.router.navigate(['/inventory-manager']);
      } else {
        this._flashMessagesService.show(r['message'], { cssClass: 'alert-danger' });
        // this.router.navigate(['/inventory-manager']);
      }
    },
      error => {
        alert('Network Error uploadmanager API');
        this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        // this.router.navigate(['/inventory-manager']);
      });
  }



  onDateChanged(type, event: IMyDateModel): void {
    // date selected
    if (type === 'month') {
      this.model['getmonth'] = event;

    } else {
      this.model['getyear'] = event;
    }
  }

  deleteEmp(id) {
    if (confirm('Deleting of this Employee is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deletEMP(id).subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.movePreviousNext(this.model, 0)
        },
          error => {
            alert('Error in delete');
            this.showLoader = false;
          });
      }
    }

  }


  deleteupload() {
    if (confirm('Deleting of this record is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deleteuploadEMP(this.model.id, 'id', 'employee_profile').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.uploads_name.inventory_manager_upload_path = {
            resume_path: '',
            resume_temp_path: '',
          };
          this.model['resume_path'] = '';
          this.model['resume_temp_path'] = '';
        },
          error => {
            alert('Error in delete');
            this.showLoader = false;
          });
      }
    }
  }


  movePreviousNext(modelVal, n) {
    this.showLoader = true;
    this.loginservice.movePreviousNextemp(modelVal, n, 'employee_profile', this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            this.model = data['comp_details'][0];
            this.Emp_Id = this.model.id;
          } else {
            this._flashMessagesService.show('No record found!', { cssClass: 'alert-danger' });
          }
          this.showLoader = false;
        },
        error => {
          alert('Network Error movePreviousNextemp API');
          this._flashMessagesService.show('No record found!', { cssClass: 'alert-danger' });
          this.showLoader = false;
        });

  }

  CheckPhone(value, name) {
    // Regular expression to check for pure integers
    const pureIntegerRegex = /^[0-9]+$/;

    // Regular expression to check for pure strings (alphabets only)
    const pureStringRegex = /^[a-zA-Z]+$/;

    // Check if the value is a pure integer
    if (pureIntegerRegex.test(value)) {

    }
    // Check if the value is a pure string
    else if (pureStringRegex.test(value)) {
      this.model[name] = '';
      this._flashMessagesService.show('Invalid Number', { cssClass: 'alert-danger' });
      // alert('Invalid Number');
    }
    // Check if the value is a mix of both integer and string
    else if (/^[a-zA-Z0-9]+$/.test(value)) {
      this.model[name] = '';
      this._flashMessagesService.show('Invalid Number', { cssClass: 'alert-danger' });
      // alert('Invalid Number');
    }
    // If none of the above, then it contains special characters
    else {
      this.model[name] = '';
      this._flashMessagesService.show('Invalid Number', { cssClass: 'alert-danger' });
      // alert('Invalid Number');
    }
  }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccess = !!mod.add;
      this.editAccess = !!mod.edit;
      this.viewAccess = !!mod.view;
      this.deleteAccess = !!mod.delete;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccess = false;
      this.editAccess = false;
      this.viewAccess = false;
      this.deleteAccess = false;
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/emp-details/emp-details.component.ts